<template>
  <div class="ei-pages">
    <a class="prev" ref="prev" @click="changePrev"><img src="../eiuov-ui/_ei-flower/9.png" alt=""></a>
    <a class="number" ref="index" @click="changeCurrent(index)" v-for="(item,index) in pageArray"
       :key="index">{{ item }}</a>
    <a class="next" ref="next" @click="changeNext"><img src="../eiuov-ui/_ei-flower/9.png" alt=""></a>
  </div>
</template>

<script>
export default {
  name: 'EiPages',
  props: {
    total: {
      type: Number,
      required: true
    },
    pageNum: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      currentIndex: 0,
      prevImgUrl: '/upload/page/page_prev.png',
      pageArray: [],
      hideNext: false,
      hidePrev: true,
    }
  },
  watch: {
    total (newV, oldV) {
      if (newV !== oldV) {
        this.init()
      }
    },
  },
  methods: {
    init () {
      console.log('EiPages total:', this.total)
      console.log('EiPages pageNum:', this.pageNum)
      console.log('EiPages pageSize:', this.pageSize)
      this.pageArray = []
      for (let i = 0; i < Math.ceil(this.total / this.pageSize); i++) {
        this.pageArray.push(i + 1)
      }
      this.$set(this, 'pageArray', this.pageArray)
      setTimeout(() => {
        this.changeCurrent(this.pageNum - 1)
      }, 0)
    },
    changePrev () {
      this.currentIndex--
      this.changeCurrent(this.currentIndex)
    },
    changeNext () {
      this.currentIndex++
      this.changeCurrent(this.currentIndex)
    },
    changeCurrent (index) {
      this.currentIndex = index
      this.$emit('pageNumChange', index + 1)
      for (let i = 0; i < this.pageArray.length; i++) {
        if (index === i) {
          this.$refs['index'][i].classList.add('current')
        } else {
          this.$refs['index'][i].classList.remove('current')
        }
      }
      if (index === 0) {
        this.$refs['prev'].classList.add('opacity0')
      } else {
        this.$refs['prev'].classList.remove('opacity0')
      }
      if (index === this.pageArray.length - 1) {
        this.$refs['next'].classList.add('opacity0')
      } else {
        this.$refs['next'].classList.remove('opacity0')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.ei-pages {
  padding: 35px 0;
  text-align: center;
}

.ei-pages a {
  display: inline-block;
  width: 30px;
  height: 30px;
  padding: 5px;
  margin: 5px 5px;
  font-size: 18px;
  line-height: 20px;

  &.current {
    background: #987444;
    border-radius: 50%;
    color: #fff;
    transition: all 0.3s ease;
    pointer-events: none;
    cursor: not-allowed;
  }

  &.prev {
    &.opacity0 {
      opacity: 0;
      transition: all 0.3s ease;
    }

    img {
      margin-top: -10px;
      margin-left: -55px;
      width: 60px;
      vertical-align: middle;
    }
  }

  &.next {
    &.opacity0 {
      opacity: 0;
      transition: all 0.3s ease;
    }

    img {
      margin-top: -10px;
      width: 60px;
      margin-left: 15px;
      vertical-align: middle;
      transform: scaleX(-1);
    }
  }
}
</style>
